import React from "react";
import { Link } from "react-router-dom";
import malbecEtiqueta from "../../../assets/malbecReservaEtiqueta.jpg";
import CabernetEtiqueta from "../../../assets/cabernetEtiqueta.jpg";
import corteEtiqueta from "../../../assets/corte2019reserva.jpg";
import partidaEspecialEtiqueta from "../../../assets/partidaEspecialEtiqueta.png";
import corte2021 from "../../../assets/etiqueta1.jpg";
import malbec2021 from "../../../assets/etiqueta2.jpg";
import cabernet2021 from "../../../assets/etiqueta3.jpg";
import "./s.css";

const Etiquetas = () => {
  return (
    <div className="contenedor-etiquetas">
      <div className="etiquetas">
        <div className="etiquetas-text">
          <div>
            <h1>LAS ETIQUETAS</h1>
            <p>
              Cuando <strong>ARTE Y VINO SE HACEN UNO:</strong> nuestras raíces
              están en nuestro diálogo con el arte, un enfoque que nos hace
              únicos.
            </p>
            <p>
              Los vinos de Osvaldo revelan el paisaje y la cultura típica de
              esta región. Nuestras etiquetas interpretan este paisaje y su
              cultura, son fragmentos de obras del{" "}
              <strong>artista mendocino Cristian Delhez.</strong> Incansable
              relator de historias dibujadas, Cristian fue un artista plástico,
              grabador, dibujante y pintor que dejó una huella imborrable en el
              patrimonio cultural mendocino.
            </p>
            <p>
              Cristian Delhez nos compartió generosamente sus obras. Junto a su
              hijo Iván, seleccionamos algunos fragmentos de ellas para
              identificar nuestros vinos.
            </p>
            <p>
              Te invitamos a conocer más obras del{" "}
              <Link
                to="https://www.instagram.com/crisdelhez/"
                target="_blank"
              >
                <u>artista</u>
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <div className="etiquetasImg">
        <div>
          <div>
            <img src={malbecEtiqueta} alt="Malbec Reserva" />
          </div>
          <h3>
            Malbec Reserva
            <br />
            "Jardín japonés"
          </h3>
          <p>
            Fragmento.
            <br />
            Dibujo a rodillo y tinta de impresión. 2005.
          </p>
        </div>
        <div>
          <div>
            <img src={CabernetEtiqueta} alt="Cabernet Sauvignon Reserva" />
          </div>
          <h3>
            Cabernet Sauvignon Reserva
            <br />
            "Pájaro inconcluso"
          </h3>
          <p>
            Fragmento.
            <br />
            ....Y cuando aparece un pájaro ya todo parece estar en su lugar....
          </p>
        </div>
        <div>
          <div>
            <img src={corteEtiqueta} alt="Corte Reserva" />
          </div>
          <h3>
            Corte Reserva
            <br />
            "Espanta espanta pájaros y pájaros"
          </h3>
          <p>
            Fragmento.
            <br />
            Dibujo con plumín (hipodérmica) y acuarela. 2017.
          </p>
        </div>
        <div>
          <div>
            <img src={partidaEspecialEtiqueta} alt="Petit Verdot Reserva" />
          </div>
          <h3>
            Petit Verdot Reserva
            <br />
            Partida Especial
          </h3>
          <p>
            Fragmento.
            <br />
            "Aparecen otros seres para charlar... ¿quién le dijo a quién?"
            <br />
            Relatos dibujados.
          </p>
        </div>
      </div>
      <div className="etiquetasBotellas">
        <div>
          <img src={corte2021} alt="corte2021" />
          <img src={malbec2021} alt="malbec2021" />
          <img src={cabernet2021} alt="cabernet2021" />
        </div>
        <p>
          Varietales Malbec, Cabernet y Corte Malbec Cabernet. Fragmento,
          "Tránsito de Cuero y huesos", acuarela. 2018.
        </p>
      </div>
    </div>
  );
};

export default Etiquetas;
